<template>

  <div

    class="ni-section-header"

    :class="{

      'ni-section-header--dark': variant === 'dark'

    }"

  >

    <div class="ni-section-header__left">

      <span class="ni-section-header__bar" aria-hidden="true"></span>

      <div class="ni-section-header__text">

        <h2 class="ni-section-header__title">

          <slot name="title">{{ title }}</slot>

        </h2>

        <span v-if="subtitle" class="ni-section-header__subtitle">{{ subtitle }}</span>

      </div>

    </div>

    <slot name="right">

      <MoreLink v-if="moreHref" :href="moreHref" :lang="lang" />

    </slot>

  </div>

</template>



<script>

import MoreLink from './MoreLink.vue';



export default {

  name: 'SectionHeader',

  components: { MoreLink },

  props: {

    title: { type: String, default: '' },

    subtitle: { type: String, default: '' },

    moreHref: { type: String, default: '' },

    lang: { type: String, default: 'zh' },

    variant: { type: String, default: 'default' }

  }

};

</script>

